export default __webpack_public_path__ + "static/media/Blog13.9aa668a2.png";